import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Language = ({ width, height, fill, ...props }) => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill={fill}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.37 11.79C12.35 12.12 12.08 12.37 11.75 12.37V12.34H11.71C9.96 12.23 8.31 11.39 7.17 10.08C6.02 11.35 4.51 12.35 2.63 12.35C2.29 12.35 2.01 12.07 2.01 11.73C2.01 11.39 2.29 11.11 2.63 11.11C5.79 11.11 7.81 7.25 8.55 5.52H2.62C2.28 5.52 2 5.24 2 4.9C2 4.56 2.28 4.28 2.62 4.28H6.56V2.62C6.56 2.28 6.84 2 7.18 2C7.52 2 7.8 2.28 7.8 2.62V4.29H11.74C12.08 4.29 12.36 4.57 12.36 4.91C12.36 5.25 12.08 5.53 11.74 5.53H9.9C9.63 6.24 8.99 7.71 7.97 9.11C8.9 10.27 10.29 11.02 11.79 11.12C12.13 11.15 12.39 11.45 12.37 11.79ZM17.2001 10.89L21.9401 21.11C22.0901 21.42 21.9501 21.79 21.6401 21.94C21.5601 21.98 21.4701 22 21.3801 22C21.1401 22 20.9201 21.87 20.8101 21.64L19.2401 18.26H14.0301L12.4601 21.64C12.3101 21.94 11.9401 22.08 11.6301 21.94C11.3301 21.79 11.1901 21.42 11.3301 21.11L16.0701 10.89C16.2701 10.45 16.9901 10.45 17.2001 10.89ZM16.6401 12.64L14.6101 17.01H14.6201H18.6701L16.6401 12.64Z"
    />
  </svg>
)

export default withDefaultStyles(Language)
